import cn from 'classnames';
import {forwardRef, ReactNode, Ref} from 'react';
import Button, {IProps as IButtonProps} from './Button';
import SingleText from './SingleText';
import Text, {IProps as ITextProps} from './Text';

export interface IProps extends IButtonProps {
  // childen이 component일때는 메인 Text(ex. 100원(main(100), sub(원)))의 variant를 설정한다.
  textClassName?: string;
  // width / height : px, 입력하지 않으면 부모의 속성(ex. flex)이나 children의 크기에 따라 결정된다.
  width?: string;
  height?: string;
  as?: ITextProps['as'];
  isEllipsisText?: boolean;
  beforeElement?: ReactNode;
  isActiveTextOpacity50?: boolean;
}

function TextButton(
  {
    width,
    height,
    children,
    className,
    textClassName,
    style,
    as = 'span',
    isEllipsisText,
    beforeElement,
    isActiveTextOpacity50,
    ...rest
  }: IProps,
  ref: Ref<HTMLButtonElement>
) {
  const TextComponent = children ? (isEllipsisText ? SingleText : Text) : null;
  return (
    <Button
      ref={ref}
      className={cn('px-10 py-0', className, {
        'button-active': isActiveTextOpacity50,
      })}
      style={{...style, width, height}}
      {...rest}
    >
      {beforeElement}
      {TextComponent && (
        <TextComponent
          className={cn('pointer-events-none', textClassName, {
            block: isEllipsisText,
            'text-active-opacity-50': isActiveTextOpacity50,
          })}
          as={as}
        >
          {children}
        </TextComponent>
      )}
    </Button>
  );
}

export default forwardRef(TextButton);
